import type { AddAddressRequest, Address } from '~/api/DeliveryAddress';
import type { DeliveryAddress } from '~/stores/UserStore';
import {
  destinationKindForUsage,
  type ETADestinationKind,
} from '~/utils/destinationKind';

type PartnerPickupAddressRequest = Pick<
  AddAddressRequest,
  'pup_type' | 'pup_provider' | 'pup_external_id' | 'pickup_point_id'
>;

export const isPartnerPickupAddress = (address: Address): boolean =>
  address.pup_type === 'partner' && !!address.pup_external_id;

/**
 * ETA destination kind of a saved address being picked. It is not active yet,
 * so the store would otherwise resolve the kind from the PREVIOUS address.
 */
export const destinationKindForAddress = (
  address: Address,
): ETADestinationKind =>
  isPartnerPickupAddress(address)
    ? 'partner_pup'
    : destinationKindForUsage(address.usage);

export const partnerPickupFromAddress = (
  address: Address,
): Pick<DeliveryAddress, 'pickupPointId' | 'partnerPupExternalId'> =>
  isPartnerPickupAddress(address)
    ? {
        pickupPointId: address.pickup_point_id ?? null,
        partnerPupExternalId: address.pup_external_id ?? null,
      }
    : {};

export const partnerPickupAddressRequest = (
  deliveryAddress: DeliveryAddress | null | undefined,
  provider: string | undefined,
): PartnerPickupAddressRequest =>
  deliveryAddress?.partnerPupExternalId
    ? {
        pup_type: 'partner',
        pup_provider: provider,
        pup_external_id: deliveryAddress.partnerPupExternalId,
        pickup_point_id: deliveryAddress.pickupPointId ?? undefined,
      }
    : {};
